import { Box } from "@mui/material";
import SetupCC from "components/setupCC";
import InputField from "components/ui/inputField";
import * as yup from "yup";

const Applythrough = () => {
  const initialValues = {
    name: "",
  };
  return (
    <SetupCC
      shouldReload
      name="Apply Through Status"
      baseRouteKey="projectCustomerAdmissionApplyThroughs"
      moduleKey="apply-through"
      columns={[
        { id: "name", label: "Name", minWidth: 100 },
        {
          id: "action",
          label: "Actions",
          style: { width: "150px" },
          align: "center",
        },
      ]}
      actions={["edit", "delete"]}
      conditionalColumns={(row, column, value) => {
        return (
          <>
            {column?.id === "color" ? (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Box
                  sx={{
                    bgcolor: value,
                    height: "20px",
                    width: "20px",
                    borderRadius: "5px",
                  }}
                ></Box>
              </Box>
            ) : (
              value
            )}
          </>
        );
      }}
      getInitialValues={(data) => {
        if (data?.id) {
          let obj = {};
          for (const key in initialValues) {
            obj[key] = data[key];
          }
          return obj;
        } else return initialValues;
      }}
      validationSchema={yup.object({
        name: yup.string().required("Name is required!"),
      })}
      allFields={(formik) => (
        <>
          <InputField name="name" label="Status Name" formik={formik} />
        </>
      )}
    ></SetupCC>
  );
};

export default Applythrough;
